module.exports = __webpack_public_path__ + "static/media/notification-menu.63d36490.svg";